import http from './utils';
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;
export const getCommunityTimeline: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = c => {},
) => {
  return http({
    url: `${prefix}/overview/community_timeline`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getMentionsStatsList: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = c => {},
) => {
  return http({
    url: `${prefix}/overview/mentions_stats_list
`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getMentionsStatsTimeline: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = c => {},
) => {
  return http({
    url: `${prefix}/overview/mentions_stats_timeline
`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getCommunityMetricStats: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = c => {},
) => {
  return http({
    url: `${prefix}/overview/community_metric_stats`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

/**
 * 事件详情请求参数
 * API: POST /api/v1/opinion_pc/overview/anomaly_detail
 */
export interface IEventDetailParams {
  edition_unified_id: string;
  start_time: string;
  end_time: string;
  overview_title: string;
}

/**
 * 事件详情 - 评论项
 */
export interface ICommentItem {
  channel: string;
  summary: string;
  url: string;
  comment_type: string;
}

/**
 * 事件详情 - 影响因素
 */
export interface IEventDetailFactor {
  name: string;
  contribution: number;
  trend: string;
  detail: string;
  comment_list: ICommentItem[];
}

/**
 * 事件详情 - 相关链接
 */
export interface IEventDetailLink {
  text: string;
  url: string;
}

/**
 * 事件详情 - 单个 Region 详情结构
 * API: POST /api/v1/opinion_pc/overview/anomaly_detail
 */
export interface IEventDetailRegionItem {
  detail: {
    start_date: string;
    end_date: string;
    overview_title: string;
    overview: string;
    overview_contribution: number;
    overview_trend: string;
    factors: IEventDetailFactor[];
    links: IEventDetailLink[];
    remark: string;
  };
}

/**
 * 获取事件详情数据响应
 * API: POST /api/v1/opinion_pc/overview/anomaly_detail
 * 返回 list 对象，以 region 为 key
 */
export interface IEventDetailListResponse {
  list: Record<string, IEventDetailRegionItem>;
}

export function getEventDetail(
  payload: {data: IEventDetailParams},
): Promise<IEventDetailListResponse> {
  return http({
    url: `${prefix}/overview/anomaly_detail`,
    method: 'post',
    ...payload,
  }) as Promise<IEventDetailListResponse>;
}
/**
 * 获取游戏每日舆情 GPT 分析与事件总结
 * API: POST /api/v1/opinion_pc/overview/summary_event
 */
export const getSummaryEvent: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c: any) => {}) => {
  return http({
    url: `${prefix}/overview/summary_event`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
};

/**
 * 异常事件时间线 - 请求参数
 */
export interface IAnomalyTimelineParams {
  edition_unified_id: string;
  date_type: 'daily' | 'weekly' | 'monthly' | 'hourly';
  start_time: string;
  end_time: string;
}

/**
 * 异常事件时间线 - 影响因素
 */
export interface IAnomalyTimelineFactor {
  name: string;
  contribution: number;
  trend: string;
}

/**
 * 异常事件时间线 - 时间线项
 */
export interface IAnomalyTimelineItem {
  time: string;
  start_date: string;
  end_date: string;
  overview_title: string;
  overview_contribution: number;
  overview_trend: string;
  factors: IAnomalyTimelineFactor[];
  /** 区域代码，可通过 regionCn 映射获取中文名称 */
  region?: keyof typeof import('@op/constants').regionCn;
}

/**
 * 异常事件时间线 - 响应数据
 */
export interface IAnomalyTimelineResponse {
  timeline: IAnomalyTimelineItem[];
  timeline_of_start_time: string;
  timeline_of_end_time: string;
}

/**
 * 查询异常事件时间线
 * API: POST /api/v1/opinion_pc/overview/anomaly_timeline
 */
export const getAnomalyTimeline = (config: {
  data: IAnomalyTimelineParams;
  cancelToken?: any;
  headers?: any;
}): Promise<IAnomalyTimelineResponse> => {
  return http({
    url: `${prefix}/overview/anomaly_timeline`,
    method: 'post',
    data: config.data,
    cancelToken: config.cancelToken,
    headers: config.headers,
  }) as Promise<IAnomalyTimelineResponse>;
};

export interface ICommunityTimelineTopItem {
  comment_uin: string;
  comment_time: string;
  content: string;
  content_url: string;
  view: number;
  tweets_like: number;
  tweets_reply: number;
  engagement: number;
  media_type: string;
  video_detail: string;
  channel_name: string;
}

export interface ICommunityTimelineTopResponse {
  list: ICommunityTimelineTopItem[];
  total: number;
}

/**
 * Overview Community - 折线点击 Top 帖子列表
 * API: POST /api/v1/opinion_pc/overview/community_timeline_top
 */
export const getCommunityTimelineTop = (config: {
  data: Record<string, any>;
  cancelToken?: any;
  headers?: any;
}): Promise<ICommunityTimelineTopResponse> => {
  return http({
    url: `${prefix}/overview/community_timeline_top`,
    method: 'post',
    data: config.data,
    cancelToken: config.cancelToken,
    headers: config.headers,
  }) as Promise<ICommunityTimelineTopResponse>;
};
